import React from "react";
import {connect} from "react-redux";
import BsForm from "components/form/BsForm";
import PagePermission from "components/permission/PagePermission";
import {fetchSystemConfig} from "core/actions/system-config-actions";
import {ADMIN} from "core/utils/permissions";
import UserHelpSettingsActions from "./UserHelpSettingsActions";

import './UserHelpSettings.scss';
import {withTranslation} from "react-i18next";

class UserHelpSettings extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    props.fetchSystemConfig(props.match.params.systemId);
  }

  onHandleEditHelp() {
    this.props.history.push('/system/' + this.props.match.params.systemId + '/edit-settings/general-help')
  }

  render() {
    const { t } = this.props;

    if (this.props.systemConfig) {
      const formConfig = {
        fields: [],
        title: {
          actions: <UserHelpSettingsActions onHandleEditHelp={this.onHandleEditHelp.bind(this)}
                                            config={this.props.systemConfig}/>
        }
      };

      let help;
      if (this.props.systemConfig.generalHelpPreview) {
        help = <div className="general-help__content"
                    dangerouslySetInnerHTML={{__html: this.props.systemConfig.generalHelpPreview}}/>;
      } else {
        help = <div className="general-help__no-data">
          {t('user_config.no_user_help_label')}
        </div>;
      }

      return (
          <div className="bs-form-container">
            <PagePermission anonymous={false} permission={ADMIN}/>
            <BsForm
                config={formConfig}
                formData={{}}
                disabled={true}/>

            {help}
          </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    systemConfig: state.systemConfig.systemConfig
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSystemConfig: (systemId) => {
      dispatch(fetchSystemConfig(systemId));
    }
  };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(UserHelpSettings));
